const map = {
  'api.udache.com': 'api-hk.udache.com',
  'pay.udache.com': 'pay-hk.udache.com',
  'pay.diditaxi.com.cn': 'pay-hk.diditaxi.com.cn',
  'epassport.diditaxi.com.cn': 'epassport-hk.diditaxi.com.cn',
  'common.diditaxi.com.cn': 'common-hk.diditaxi.com.cn',
  'ucenter.diditaxi.com.cn': 'ucenter-hk.diditaxi.com.cn',
  'page.udache.com': 'page-hk.udache.com',
  'winter-campaign.xiaojukeji.com': 'winter-campaign-hk.xiaojukeji.com',
  'v.didi.cn': 'v-hk.didi.cn',
  's.didi.cn': 's-hk.didi.cn',
  'res.xiaojukeji.com': 'res-hk.xiaojukeji.com',
  'passport.didichuxing.com': 'passport-hk.didichuxing.com',
  'help.xiaojukeji.com': 'help-hk.xiaojukeji.com',
  'safe.xiaojukeji.com': 'safe-hk.xiaojukeji.com',
  'bosp-api.xiaojukeji.com': 'bosp-api-hk.xiaojukeji.com',
}

const keys = Object.keys(map)

export const HKDomainConvert = (url, isHK) => {
  if (!isHK) return url
  const key = keys.find(key => url.indexOf(key) > -1)
  if (key) return url.replace(key, map[key])
  return url
}
